// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-badge.lit.scss INSTEAD!
import { css } from 'lit';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-badge-font-size=0.625rem] - font size for badge
   */
  --sh-badge-font-size: 0.625rem;
  /* 
   * @cssprop [--sh-badge-medium-font-size=0.75rem] - font size for medium size
   */
  --sh-badge-medium-font-size: 0.75rem;
  /* 
   * @cssprop [--sh-badge-min-width=1rem] - min width of badge
   */
  --sh-badge-min-width: 1rem;
  /* 
   * @cssprop [--sh-badge-max-width=4rem] - max width of badge
   */
  --sh-badge-max-width: 4rem;
  /* 
   * @cssprop [--sh-badge-height=1rem] - height of badge
   */
  --sh-badge-height: 1rem;
  /* 
   * @cssprop [--sh-badge-line-height=0.6875rem] - line height of badge
   */
  --sh-badge-line-height: 0.6875rem;
  /* 
   * @cssprop [--sh-badge-medium-line-height=0.75rem] - line height of medium badge
   */
  --sh-badge-medium-line-height: 0.75rem;
  /* 
   * @cssprop [--sh-badge-label-size=1rem] - size of empty badge in case no label is set
   */
  --sh-badge-label-size: 1rem;
  /* 
   * @cssprop [--sh-badge-label-size-medium=1.25rem] - size of empty badge in case  label is set for medium size
   */
  --sh-badge-label-size-medium: 1.25rem;
  /* 
   * @cssprop [--sh-badge-no-label-size=0.5rem] - size of empty badge in case no label is set for medium size
   */
  --sh-badge-no-label-size: 0.5rem;
  /* 
   * @cssprop [--sh-badge-no-label-size-medium=0.625rem] - size of empty badge in case no label is set for medium size
   */
  --sh-badge-no-label-size-medium: 0.625rem;
  /* 
   * @cssprop [--sh-badge-padding=0 0.3125rem 0 0.3125rem] - padding for text labels
   */
  --sh-badge-padding: 0 0.3125rem 0 0.3125rem;
  /* 
   * @cssprop [--sh-badge-padding-medium=0 0.5rem 0 0.5rem] - Padding for medium-sized text labels
   */
  --sh-badge-padding-medium: 0 0.5rem 0 0.5rem;
  /* 
   * @cssprop [--sh-badge-icon-font-size=1.5rem] - applied to interllay used icon as --sh-icon-font-size-xs
   */
  --sh-badge-icon-font-size: 1.5rem;
  /* 
   * @cssprop [--sh-badge-label-type-padding=0rem 0.375rem 0rem 0.125rem] - padding is applied if both type and label are defined 
   */
  --sh-badge-label-type-padding: 0rem 0.375rem 0rem 0.125rem;
  /* 
   * @cssprop [--sh-badge-label-type-padding-medium=0rem 0.5rem 0rem 0.25rem] - Padding is applied when both type and label are defined for the medium size
   */
  --sh-badge-label-type-padding-medium: 0rem 0.5rem 0rem 0.25rem;
  /* 
   * @cssprop [--sh-badge-label-line-height=1rem] - line-height is applied if both type and label are defined 
   */
  --sh-badge-label-line-height: 1rem;
  /* 
   * @cssprop [--sh-badge-border-radius=var(--sh-radius-full)] - badge border radius
   */
  --sh-badge-border-radius: var(--sh-radius-full);
  /* 
   * @cssprop [--sh-badge--success-accessible=32,136,58] - success badge with label color value
   */
  --sh-badge--success-accessible: 32,136,58;
  /* 
   * @cssprop [--sh-badge--error-accessible=227, 43, 38] - error badge with label color value
   */
  --sh-badge--error-accessible: 227, 43, 38;
  /* 
   * @cssprop [--sh-badge---base--accessible=1, 132, 132] - base color of the badge with label
   */
  --sh-badge---base--accessible: 1, 132, 132;
  /* 
   * @cssprop [--sh-badge-medium-icon-badge=1.25rem] - Height and width of the badge with only the icon.
   */
  --sh-badge-medium-icon-badge: 1.25rem;
  /* 
   * @cssprop [--sh-badge-medium-min-width=1.25rem] - min width of the medium badge
   */
  --sh-badge-medium-min-width: 1.25rem;
  /* 
   * @cssprop [--sh-badge-medium-max-width=5rem] - max width of the medium badge
   */
  --sh-badge-medium-max-width: 5rem;
}

:host {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  padding: var(--sh-badge-padding);
  border-radius: var(--sh-badge-border-radius);
  font: var(--title-2);
  font-size: var(--sh-badge-font-size);
  color: var(--text-white);
  max-width: var(--sh-public-badge-max-width, var(--sh-badge-max-width));
  min-width: var(--sh-badge-min-width);
  width: fit-content;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  height: var(--sh-badge-height);
  line-height: var(--sh-badge-line-height);
  box-sizing: border-box;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: auto;
  text-rendering: optimizeLegibility;
}

sh-icon {
  --sh-icon-font-size-xs: var(--sh-badge-icon-font-size);
}

:host(:not([label]):not([type=error]):not([type=success]):not([type=warning])),
:host([label=""]:not([type=error]):not([type=success]):not([type=warning])) {
  width: var(--sh-badge-no-label-size);
  height: var(--sh-badge-no-label-size);
  max-width: var(--sh-badge-no-label-size);
  max-height: var(--sh-badge-no-label-size);
  min-width: var(--sh-badge-no-label-size);
  min-height: var(--sh-badge-no-label-size);
  padding: 0px;
  background: rgba(var(--ui-0), var(--opacity-1));
}

:host([label]:not([label=""])) {
  background-color: rgba(var(--sh-badge---base--accessible));
}

:host([show-label][label][type=error]),
:host([show-label][label][type=warning]),
:host([show-label][label][type=success]) {
  display: flex;
  padding: var(--sh-badge-label-type-padding);
  line-height: var(--sh-badge-label-line-height);
}

:host([label][type=error]) .label-span,
:host([label][type=warning]) .label-span,
:host([label][type=success]) .label-span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:host([label][type=warning]) .label-span {
  color: black;
}

:host([type]:not([label])) {
  padding: 0rem;
  background: transparent;
}

:host([type=error]) sh-icon {
  color: var(--functional-red);
}

:host([type=warning]) sh-icon {
  color: rgb(var(--functional-yellow));
}

:host([type=success]) sh-icon {
  color: var(--functional-green);
}

:host([type=success][label]) sh-icon {
  --functional-green: rgb(var(--sh-badge--success-accessible));
  background: var(--functional-green);
}

:host([show-label][type=error]) {
  --functional-red: rgb(var(--sh-badge--error-accessible));
  background: var(--functional-red);
}

:host([show-label][type=warning]) {
  background: rgb(var(--functional-yellow));
}

:host([show-label][type=success]) {
  --functional-green: rgb(var(--sh-badge--success-accessible));
  background: var(--functional-green);
}

:host([disabled]:not([type])) {
  color: var(--text-white-disabled);
  background: rgba(var(--ui-0), var(--opacity-5));
}

:host([disabled][type]) {
  opacity: 0.2;
}

:host([neutral]:not([type=error]):not([type=success]):not([type=warning])) {
  background: rgb(var(--badge-no-label-bg));
  box-shadow: inset 0 0 0 1px rgba(var(--ui-1), var(--opacity-6));
}

:host([neutral][label]:not([type=error]):not([type=success]):not([type=warning])) {
  color: var(--color-text-subtle);
  background: rgb(var(--ui-9));
}

:host([neutral][disabled][label]:not([type=error]):not([type=success]):not([type=warning])) {
  color: var(--text-disabled);
  background: rgba(var(--ui-9), var(--opacity-4));
}

:host([neutral][disabled]:not([type=error]):not([type=success]):not([type=warning])) {
  background: rgba(var(--badge-no-label-bg), var(--opacity-4));
}

:host([size=small]) {
  font-size: var(--sh-badge-font-size);
  line-height: normal;
  height: var(--sh-badge-label-size);
}

:host([size=medium]) {
  font-size: var(--sh-badge-medium-font-size);
  line-height: normal;
  height: var(--sh-badge-label-size-medium);
  padding: var(--sh-badge-padding-medium);
  min-width: var(--sh-badge---sh-badge-medium-min-width);
  max-width: var(--sh-public-badge-max-width, var(--sh-badge-medium-max-width));
}

:host(:not([label])[size=medium]:not([type=error]):not([type=success]):not([type=warning])) {
  padding: 0px;
  width: var(--sh-badge-no-label-size-medium);
  height: var(--sh-badge-no-label-size-medium);
  max-width: var(--sh-badge-no-label-size-medium);
  max-height: var(--sh-badge-no-label-size-medium);
  min-width: var(--sh-badge-no-label-size-medium);
  min-height: var(--sh-badge-no-label-size-medium);
}

:host(:not([label])[disabled]:not([neutral]):not([type=error]):not([type=success]):not([type=warning])) {
  background: rgba(var(--ui-0), var(--opacity-5));
}

:host(:not([label])[variant=squared]:not([type=error]):not([type=success]):not([type=warning])) {
  border-radius: var(--sh-radius-full);
}

:host([variant=rounded]) {
  border-radius: var(--sh-radius-full); /* Full radius for rounded corners */
}

/* Squared Badge */
:host([variant=squared]) {
  border-radius: var(--sh-radius-small-container); /* Small radius for squared corners */
}

:host .label-span {
  text-overflow: ellipsis;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
}

:host([show-label][label][type=error][size=medium]),
:host([show-label][label][type=warning][size=medium]),
:host([show-label][label][type=success][size=medium]) {
  padding: var(--sh-badge-label-type-padding-medium);
}

:host([type][size=medium]:not([label])) {
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--sh-badge-medium-icon-badge);
  width: var(--sh-badge-medium-icon-badge);
}`;